<template>
	<button :class="getClassName()" @click="handleClick">
		{{ label }}
	</button>
</template>

<script>
export default {
	props: {
		size: {
			type: Number,
			default: 56
		},
		color: {
			type: 'primary' | 'gray' | 'secondary',
			default: 'primary'
		},
		label: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
		ghost: {
			type: Boolean,
			default: false
		},
		full: {
			type: Boolean,
			default: true
		},
		onClick: {
			type: Function,
			required: true
		}
	},
	methods: {
		getClassName() {
			let result = 'button_container'
			switch (this.size) {
				case 44:
					result = result + ` button_44 button_3`
					break
				case 36:
					result = result + ` button_36 button_3`
					break
				default:
					result = result + ` button_56 body_6_M`
					break
			}

			switch (this.color) {
				case 'primary':
					result = result + ` button_primary${this.ghost ? '_ghost' : ''}`
					break
				case 'gray':
					result = result + ` button_gray${this.ghost ? '_ghost' : ''}`
					break
				case 'secondary':
					result = result + ` button_secondary${this.ghost ? '_ghost' : ''}`
					break
			}
			return result + (this.disabled ? ' button_disabled' : '') + (this.full ? ' button_full' : '')
		},
		handleClick() {
			if (!this.disabled) {
				this.onClick()
			}
		}
	}
}
</script>

<style scoped>
.button_container {
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 8px;
	transition: background 0.3s;
}

.button_full {
	width: 100%;
}

.button_56 {
	padding: 16px 12px;
	height: 56px;
}

.button_44 {
	padding: 16px 10px;
	height: 44px;
}

.button_36 {
	padding: 8px 12px;
	height: 36px;
}

.button_primary {
	background-color: var(--primary-color-1);
	color: var(--gray-scale-12);
}

.button_primary_ghost {
	border: 1px solid var(--primary-color-1);
	background-color: var(--gray-scale-12);
	color: var(--primary-color-1);
}

.button_gray {
	background-color: var(--gray-scale-10);
	color: var(--gray-scale-2);
}

.button_gray_ghost {
	background-color: var(--gray-scale-12);
	border: 1px solid var(--gray-scale-7);
	color: var(--gray-scale-2);
}

.button_secondary {
	background-color: var(--secondary-color-3);
	color: var(--gray-scale-12);
}

.button_econdary_ghost {
	background-color: var(--gray-scale-12);
	border: 1px solid var(--secondary-color-3);
	color: var(--secondary-color-3);
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiButton.vue